import { css } from '@emotion/core';
import { tokens, applyFont, globalTokens, rgba } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
var defaultBackground = colors.neutral.trim.default;
var defaultColour = colors.neutral.heavy.default;
export var wrapper = {
  name: "1dbd6eg",
  styles: "opacity:0.9;line-height:0;"
};
export var badge = (bgColour, textColour) => /*#__PURE__*/css(applyFont(typography.mini), " text-transform:uppercase;text-shadow:0 0 4px ", rgba(globalTokens.colors.black, 0.5), ";display:inline-flex;align-items:center;margin:0px 8px 12px 0px;padding:0 12px;height:24px;color:", textColour || defaultColour, ";min-width:52px;border-radius:3px;background-color:", bgColour || defaultBackground, ";overflow:hidden;white-space:nowrap;");